export default __webpack_public_path__ + "static/media/user_placeholder.1ae459f2.jpg";